export enum ActivitySubjectType {
  Document = 'document',
}

export const MAP_ACTIVITY_SUBJECT_TYPE_TO_RESOURCE_PATH_SEGMENT = {
  [ActivitySubjectType.Document]: 'documents',
};
